"use strict";

define('libs/language.helper',['handlebars'], function (Handlebars) {
  var LanguageHelper = {
    langDefs: [],
    selLangDef: {},
    setup: function setup(langDefs) {
      this.langDefs = langDefs;
      this.setLanguage(langDefs[0].local);
      Handlebars.registerHelper('p', function (derp) {
        return new Handlebars.SafeString(LanguageHelper.phrase(derp));
      });
    },
    setLanguage: function setLanguage(newLang) {
      for (var i = 0, len = this.langDefs.length, lang; i < len; i++) {
        lang = this.langDefs[i];
        if (lang.local === newLang) {
          this.selLangDef = lang;
        }
      }
    },
    phrase: function phrase(key) {
      return LanguageHelper.selLangDef.phrases[key] || key;
    }
  };
  return LanguageHelper;
});

